import api from './api';
import {
  ProtokolSektion,
  CreateSektionRequest,
  UpdateSektionRequest,
  CreateFeldRequest,
  UpdateFeldRequest,
  ProtokolFeld,
} from '../types';

const protokollSchemaService = {
  getSchema: async (): Promise<ProtokolSektion[]> => {
    const res = await api.get('/protokoll-schema');
    return res.data;
  },

  createSektion: async (req: CreateSektionRequest): Promise<ProtokolSektion> => {
    const res = await api.post('/protokoll-schema/sektionen', req);
    return res.data;
  },

  updateSektion: async (id: number, req: UpdateSektionRequest): Promise<ProtokolSektion> => {
    const res = await api.put(`/protokoll-schema/sektionen/${id}`, req);
    return res.data;
  },

  deleteSektion: async (id: number): Promise<void> => {
    await api.delete(`/protokoll-schema/sektionen/${id}`);
  },

  createFeld: async (req: CreateFeldRequest): Promise<ProtokolFeld> => {
    const res = await api.post('/protokoll-schema/felder', req);
    return res.data;
  },

  updateFeld: async (id: number, req: UpdateFeldRequest): Promise<ProtokolFeld> => {
    const res = await api.put(`/protokoll-schema/felder/${id}`, req);
    return res.data;
  },

  deleteFeld: async (id: number): Promise<void> => {
    await api.delete(`/protokoll-schema/felder/${id}`);
  },
};

export default protokollSchemaService;
